<app-preloader *ngIf="isLoading"></app-preloader>

<div id="deals" [ngClass]="{ mobile: responsive.isMobileSignal() }">
  <h3>{{ isModeEdition ? 'Propuesta' : 'Propuestas' }}</h3>
  <ng-container *ngIf="showBtn()">
    <button
      class="tertiary"
      (click)="addNewProposal()"
      *ngIf="!isModeEdition && !proposalsReadOnly"
      [disabled]="!isValid"
      #addNewProposalBtn
      (keydown)="handleTopButtonKeydown($event)"
    >
      <i class="icon"></i>
      Nueva Propuesta
    </button>
  </ng-container>
  <div class="noData" *ngIf="formGroupArray.length == 0 && !isModeEdition">No hay información disponible</div>
  <div class="dealsList" [style.display]="isModeEdition ? 'none' : 'block'">
    @if (!responsive.isMobileSignal()) {
      <div *ngFor="let deal of formGroupArray; let i = index" class="deal">
        <app-header-deal
          [deal]="deal"
          [indexDeal]="i"
          [nameCompany]="nameCompany()"
          [idQuote]="idQuote"
          [modeEdition]="isModeEdition"
          [userId]="userId"
          [isValid]="isValid"
          [readOnlyActions]="proposalsReadOnly"
          (edit)="changeMode($event)"
          (duplicate)="duplicateProposal($event)"
          (delete)="openModalConfirmationDeal($event)"
          (addInsuranceOpen)="addInsurance($event, i)"
          (editInsurance)="changeModeInsurance($event, i)"
          (deleteInsurance)="openModalConfirmationInsurance($event, i)"
          (isSelected)="selectDeal($event, i)"
          (isSelectedInsurance)="selectedInsuranceEvent($event, i)"
        ></app-header-deal>
      </div>
    } @else {
      <div *ngFor="let deal of formGroupArray; let i = index" class="deal">
        <app-header-deal-mobile
          [deal]="deal"
          [indexDeal]="i"
          [nameCompany]="nameCompany()"
          [idQuote]="idQuote"
          [modeEdition]="isModeEdition"
          [userId]="userId"
          [readOnlyActions]="proposalsReadOnly"
          (edit)="changeMode($event)"
          (duplicate)="duplicateProposal($event)"
          (delete)="openModalConfirmationDeal($event)"
          (addInsuranceOpen)="addInsurance($event, i)"
          (editInsurance)="changeModeInsurance($event, i)"
          (deleteInsurance)="openModalConfirmationInsurance($event, i)"
          (isSelected)="selectDeal($event, i)"
          (isSelectedInsurance)="selectedInsuranceEvent($event, i)"
        ></app-header-deal-mobile>
      </div>
    }
  </div>
  <!-- <app-insurance-view></app-insurance-view> -->
  <div>
    @if (!responsive.isMobileSignal()) {
      <app-deal-form
        [customer]="customer"
        *ngIf="isModeEdition && !showInsunranceForm"
        [deal]="selectedDeal"
        [nameCompany]="nameCompany()"
        [financialService]="financialService"
        [indexDeal]="indexDeal"
        (update)="updateDeals($event)"
        (closeEdition)="closeEditionDeal($event)"
        [idQuote]="idQuote"
        [quoteType]="this.quoteType"
      >
      </app-deal-form>
    } @else {
      <app-deal-form-mobile
        [customer]="customer"
        *ngIf="isModeEdition && !showInsunranceForm"
        [deal]="selectedDeal"
        [nameCompany]="nameCompany()"
        [indexDeal]="indexDeal"
        (update)="updateDeals($event)"
        (closeEdition)="closeEditionDeal($event)"
        [idQuote]="idQuote"
        [quoteType]="this.quoteType"
      >
      </app-deal-form-mobile>
    }
  </div>
  @if (!responsive.isMobileSignal()) {
    <app-insurance-form
      *ngIf="showInsunranceForm"
      [deal]="selectedDeal"
      [customer]="customer"
      [indexInsurance]="indexInsurance"
      [nameCompany]="nameCompany()"
      [indexDeal]="indexDeal"
      [idQuote]="idQuote"
      [quoteType]="this.quoteType"
      (updateInsurance)="updateInsurance($event)"
      (closeEditionInsurance)="closeEditionInsurance($event)"
    >
    </app-insurance-form>
  } @else {
    <app-insurance-form-mobile
      *ngIf="showInsunranceForm"
      [deal]="selectedDeal"
      [customer]="customer"
      [indexInsurance]="indexInsurance"
      [nameCompany]="nameCompany()"
      [indexDeal]="indexDeal"
      [idQuote]="idQuote"
      [quoteType]="this.quoteType"
      (updateInsurance)="updateInsurance($event)"
      (closeEditionInsurance)="closeEditionInsurance($event)"
    >
    </app-insurance-form-mobile>
  }

  <ng-container *ngIf="showBtn()">
    <button
      class="tertiary"
      (click)="addNewProposal()"
      *ngIf="!isModeEdition && !proposalsReadOnly"
      [disabled]="!isValid"
      #addNewProposalBtnBottom
    >
      <i class="icon"></i>
      Nueva Propuesta
    </button>
  </ng-container>
  <ng-template #templateConfirmation>
    <app-template-confirmation
      [title]="title"
      [subtitle]="subtitle"
      [btn1]="btn1"
      [btn2]="btn2"
      (closeModal)="closeModal()"
      (actionBtn2)="delete()"
    ></app-template-confirmation>
  </ng-template>
</div>
